import api from '../../helpers/axios'

export const state = {
    personGroup: null,
    personGroups: []
};

export const getters = {
    personGroup: (state) => state.personGroup,
    personGroups: (state) => state.personGroups
};

export const mutations = {
    setPersonGroup(state, newValue) {
        state.personGroup = newValue;
    },
    setPersonGroups(state, newValue) {
        state.personGroups = newValue;
    },
};

export const actions = {
    createPersonGroup(_,  data) {
        return new Promise((resolve) => {
            api.post("/person-groups", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    updatePersonGroup(_, {id,data}) {
        return new Promise((resolve) => {
            api.put("/person-groups/"+id, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deletePersonGroup(_, id) {
        return new Promise((resolve) => {
            api.delete("/person-groups/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchPersonGroup({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/person-groups/"+id).then((res) => {
                commit("setPersonGroup", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchPersonGroups({ commit },  {page, limit, search, listType}) {
        let query = "?";
        if(listType){
            query+=`listType=${listType}`
        }else{
            if (search) {
                query += `name=${search}&`;
            }
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }
        return new Promise((resolve) => {
            api.get("/person-groups"+query).then((res) => {
                commit("setPersonGroups", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
